module.exports = __webpack_public_path__ + "media/images/user/disclaimers/step-656dce878c957555fa9bee31b9f8dc41.svg";